import React from 'react';
import { isEmpty, map, uniqueId } from 'lodash';
import { withFormik, FieldArray } from 'formik';
import Yup from 'yup';
import { getFormValue } from '../../../util/helpers';
import {
  FREQUENCY,
  FREQUENCY_UNIT,
  IDLE_TIME,
  LOCATION,
  NOTIFICATION_TEXT,
  STATUS,
  TIME_OF_DAY,
} from '../constants';
import { FormLayout, renderFormSection } from '../../common';
import Notification from './Notification';

const NOTIFICATIONS = 'notificationTemplates';

const getNewNotification = () => ({
  [NOTIFICATION_TEXT]: '',
  [LOCATION]: '',
  [IDLE_TIME]: '',
  [FREQUENCY]: '',
  [TIME_OF_DAY]: '',
  [STATUS]: true,
  tempId: uniqueId('temp-'),
});

function NotificationManagementForm(props) {
  return (
    <FormLayout {...props}>
      <FieldArray
        name={NOTIFICATIONS}
        render={fieldArray =>
          renderFormSection({
            fieldArray,
            props: {
              ...props,
              component: Notification,
              onAddSection: getNewNotification,
              title: 'Notification',
            },
          })
        }
      />
    </FormLayout>
  );
}

const toNotificationTemplateValues = notification => ({
  id: notification.id,
  tempId: notification.tempId,
  [NOTIFICATION_TEXT]: getFormValue(notification, NOTIFICATION_TEXT, ''),
  [LOCATION]: getFormValue(notification, LOCATION, undefined),
  [IDLE_TIME]: getFormValue(notification, IDLE_TIME, ''),
  [FREQUENCY]: getFormValue(notification, FREQUENCY, 0),
  [FREQUENCY_UNIT]: getFormValue(notification, FREQUENCY_UNIT, ''),
  [TIME_OF_DAY]: getFormValue(notification, TIME_OF_DAY, ''),
  [STATUS]: getFormValue(notification, STATUS, false),
});

export default withFormik({
  displayName: 'Notification Management',
  handleSubmit: (values, { props, setStatus }) =>
    props
      .onSave(values.notificationTemplates)
      .then(() => (props.isEditing ? props.onCancel() : props.onContinue()))
      .catch(error => setStatus({ saveError: error })),
  mapPropsToValues: ({ data }) => {
    return {
      notificationTemplates: isEmpty(data)
        ? [getNewNotification()]
        : map(data, toNotificationTemplateValues),
    };
  },
  validationSchema: Yup.object().shape({
    notificationTemplates: Yup.array().of(
      Yup.object().shape({
        [FREQUENCY]: Yup.number()
          .typeError('Frequency must be a number.')
          .required('Frequency is required')
          .min(1, 'Value must be greater than zero.'),
        [FREQUENCY_UNIT]: Yup.string().required('Interval is required.'),
        [NOTIFICATION_TEXT]: Yup.string().required(
          'Notification text is required.',
        ),
        [LOCATION]: Yup.number()
          .typeError('Location is required.')
          .required('Location is required.'),
        [IDLE_TIME]: Yup.number()
          .typeError('Idle Time must be a number.')
          .required('Idle Time is required.'),
        [STATUS]: Yup.boolean().required('Status is required'),
      }),
    ),
  }),
})(NotificationManagementForm);



// WEBPACK FOOTER //
// ./src/modules/NotificationManagement/components/NotificationManagementForm.js